<template>
  <div class="row">
    <div class="col col-5">
      <div class="skills-box">
        <h3 class="section-title h4">
          Topics covered
        </h3>
        <div>
          <span v-for="(skill, i) in skills.tags" :key="i" class="caption">{{ skill }}</span>
        </div>
      </div>
    </div>
    <div v-if="learn" class="col col-6 offset-1 what-learn">
      <h3 class="h4">
        What You'll Learn
      </h3>
      <p class="body-2">
        {{ learn.learn.replace(/\xA0/g,' ') }}
      </p>
      <div v-if="learn.list" class="learnings">
        <div class="row">
          <template v-for="(l, idx) in learn.list">
            <div
              v-if="l"
              :key="idx"
              class="col col-6"
            >
              <CheckIcon /> <span>{{ l }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckIcon from '../../assets/svg/icon-check.svg?vue-component';

export default {
  components: {
    CheckIcon,
  },
  props: {
    skills: { type: Object, default: () => {}, required: true },
  },
  computed: {
    learn() {
      return JSON.parse(`${this.skills.learn}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.skills-box {
  padding: var(--spacing-30);
  background: var(--main-dark-shade-1);
  border-radius: 10px;
  min-height: 368px;

  .h4 {
    text-transform: capitalize;
    color: var(--main-light);
    margin-bottom: var(--spacing-16);
  }

  div {
    display: flex;
    flex-wrap: wrap;

    span {
      background: var(--main-light-shade-2);
      border-radius: 100px;
      padding: var(--spacing-8) var(--spacing-16);
      margin: 0 var(--spacing-14) var(--spacing-12) 0;
      font-weight: 500;
      text-transform: capitalize;
    }
  }
}

.what-learn {
  .h4 {
    margin: 0;
  }

  .body-2 {
    margin: var(--spacing-24) 0;
    color: var(--main-dark-shade-3);
  }

  .learnings {
    color: var(--main-dark-shade-3);

    .row {
      margin: 0;

      div.col {
        display: flex;
        align-items: baseline;
        line-height: 150%;
        margin-bottom: var(--spacing-18);

        svg {
          width: 14px;
          height: 13px;
          margin-right: var(--spacing-12);
          flex: 0 0 auto;

          path[fill] {
            fill: var(--accent-shade-1);
          }
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .skills-box .h4,
  .what-learn .h4 {
    font-size: 21px;
  }
}

@include bp($bp-mobile) {
  .skills-learn {
    flex-direction: column-reverse;
  }

  .col:first-child {
    order: 1;
  }

  .col:nth-child(3) {
    order: 2;
  }

  .col:nth-child(5) {
    order: 3;
  }

  .col:nth-child(2) {
    order: 4;
  }

  .col:nth-child(4) {
    order: 5;
  }

  .col:nth-child(6) {
    order: 6;
  }

  .skills-box {
    min-height: auto;
  }
}
</style>
